module.exports = __webpack_public_path__ + "img/icon-download.783134e5.png";